import React, { useState } from 'react'
import { Button, Col, Row, Image } from 'antd'
import educations from 'data/educations.json'

const ExpandedData = ({ data }) => {

    const [visible, setVisible] = useState(false)

    let table = [
        { heading: "Registration Number", data: data.registrationNumber },
        // { heading: "Campus", data: data.campus.name },
        { heading: "Full Name", data: data.fullName },
        { heading: "First Name", data: data.firstName + " / " + data.firstNameUrdu },
        { heading: "Last Name", data: data.lastName + " / " + data.lastNameUrdu },
        { heading: "CNIC/B-Form", data: data.cnic },
        { heading: "Email", data: data.email },
        { heading: "Gender", data: window.toCapitalizeCase(data.gender) },
        { heading: "Date of Birth", data: window.dateFormat(data.dob, "DD-MMM-YYYY") },
        { heading: "Age", data: data.age },
        { heading: "Education", data: educations.find(education => education.value === data.education)?.label },
        { heading: "Father Name", data: data.fatherName + " / " + data.fatherNameUrdu },
        { heading: "Father CNIC", data: data.fatherCNIC },
        { heading: "Mother Name", data: data.motherName + " / " + data.motherNameUrdu },
        { heading: "Mother CNIC", data: data.motherCNIC },
        { heading: "Phone", data: <a href={`tel:+${data.phone}`} target="_blank" rel="noopener noreferrer">{data.phone}</a> },
        { heading: "WhatsApp", data: <a href={`https://wa.me/${data.whatsapp}`} target="_blank" rel="noopener noreferrer">{data.whatsapp}</a> },
        { heading: "Blood Group", data: window.toCapitalizeCase(data.bloodGroup) },
        { heading: "Religion", data: window.toCapitalizeCase(data.religion) },
        { heading: "Country", data: data.country.name },
        { heading: "Province", data: data.province.name },
        { heading: "City", data: data.city.name },
        { heading: "Address", data: data.address },
        { heading: "Short Bio", data: data.shortBio },
        { heading: "Date Created", data: window.dateFormat(data.createdAt, "dddd DD-MMM-YYYY, hh:mm:ss A") },
        // { heading: "Created By", data: data.createdBy?.fullName },
        // { heading: "Modified By", data: data.modifiedBy?.fullName },
        { heading: "Photo", data: <Button type='link' className='p-0 h-auto' onClick={() => { setVisible(true) }}>Click to See</Button> },
        { heading: "Emergency Contact Relation", data: window.toCapitalizeCase(data.emergencyContact.relation) },
        { heading: "Emergency Contact FullName", data: data.emergencyContact.fullName },
        { heading: "Emergency Contact Phone", data: <a href={`tel:+${data.emergencyContact.phone}`} target="_blank" rel="noopener noreferrer">{data.emergencyContact.phone}</a> },
        { heading: "Emergency Contact Phone (Additional)", data: <a href={`tel:+${data.emergencyContact.phone2}`} target="_blank" rel="noopener noreferrer">{data.emergencyContact.phone2}</a> },
    ]
    return (
        <>
            <Row>
                <Col xs={24} md={{ span: 14, offset: 5 }}>
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered table-hover align-middle mb-0">
                            <tbody>
                                {table.map((row, i) => {
                                    return <tr key={i}>
                                        <th>{row.heading}</th>
                                        <td>{row.data}</td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>

            <Image preview={{ visible, src: data.photoURL, onVisibleChange: (value) => { setVisible(value) } }} />
        </>
    )
}

export default ExpandedData